import { BaseModel } from './base';

export enum SegmentOnlinePaymentCaptureRequired {
  system = 'system',
  required = 0,
  notRequired = 1,
}

export const SegmentOnlinePaymentCaptureRequiredLabels: Record<string, string> = {
  system: 'api.models.segment.systemDefault',
  '0': 'api.models.segment.notRequired',
  '1': 'general.required',
};

export enum SegmentOnlineBookingAllowed {
  allowed = 1,
  notAllowed = 0,
}

export const SegmentOnlineBookingAllowedLabels: Record<SegmentOnlineBookingAllowed, string> = {
  [SegmentOnlineBookingAllowed.allowed]: 'general.allowed',
  [SegmentOnlineBookingAllowed.notAllowed]: 'general.notAllowed',
};

export class Segment extends BaseModel {
  idSegment!: number;
  name!: string;
  colour!: number;
  hexColour!: string;
  onlinePaymentCaptureRequired!: SegmentOnlinePaymentCaptureRequired;
  onlineBookingAllowed!: SegmentOnlineBookingAllowed;

  override objectID(): string | null {
    return this.idSegment?.toString() ?? null;
  }

  get variant(): string {
    switch (this.colour) {
      case 1: return 'default';
      case 2: return 'success';
      case 3: return 'warning';
      case 4: return 'danger';
      case 5: return 'info';
      case 6: return 'dark';
      default: return 'default';
    }
  }
}
